import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { Button } from "@material-ui/core";
import { trim } from "lodash";
import { createQboInvoice } from "../actions/dashboardAction";
import { useDispatch } from "react-redux";
import CircularProgress from "@material-ui/core/CircularProgress";

export default function QboConfig(props) {
  const { open, handleClose, invoiceId, accountId, onQboSuccess} = props;
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const handleSendToQbo = () => {
      console.log(invoiceId, accountId, 'invoiceId, accountId')
  
      if (!invoiceId || !accountId) {
        console.log("Missing invoiceId or accountId");
        return;
      }
      setLoading(true);
  
      const payload = {
         invoiceId: invoiceId,   
         accountId: accountId,
      };
  
      // console.log("Sending QBO payload:", payload);
  
      dispatch(createQboInvoice(payload, (status) => {
      //   console.log("QBO Invoice creation callback executed:", status);
        setLoading(false);
      //   setTimeout(() => {
      if (status === true || status === "success") {
        onQboSuccess && onQboSuccess();
       } 
          handleClose();
      //   }, 100);
      }));
    };
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth={true}
      maxWidth={'sm'}
      disableScrollLock   
    >
      <DialogTitle >
        Warning!
        <IconButton onClick={() => { handleClose() }} style={{ float: 'right' }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <p style={{lineHeight: "24px"}}>Sending this invoice to QuickBooks is irreversible. Would you like this invoice and it’s data to go to QuickBooks Online ?</p>
        <div style={{marginLeft: "400px", display: "flex", gap: "12px", marginTop: "20px"}}>
        <Button variant="contained" 
         disabled={loading}
         style={{
           color: "white",
           backgroundColor: "black",
           marginTop: "20px",
           marginRight: "10px",
           transition: "0.3s",
           boxShadow:'none',
         }}
         onClick={handleSendToQbo}
          endIcon={
            loading ? (<CircularProgress style={{ width: 22, height: 22, color: "#fff" }} />
            ) : null
          }
        >
          Yes
        </Button>
        <Button variant="outlined"  
         style={{
            background: "#fff",
            color: "#000",
            marginTop: "20px",
            paddingTop: "5 !important",
            paddingBottom: "5 !important",
            boxShadow:'none',
         }}
         onClick={handleClose}
        >
         No
        </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
